import useAuth from "@/pages/user/auth/@context/useAuth";
import { useLocation, Outlet, Navigate } from "react-router-dom";

const Authenticated = () => {
  const { auth, loading } = useAuth();
  const location = useLocation();
  const from = location?.state?.from?.pathname || "/dashboard";
  const isAuthenticated = Boolean(auth?.user);
  // const isAuthenticated = true; // for test

  return (
    <>
      {isAuthenticated && !loading ? (
        <Navigate to={from} state={{ from: location }} replace />
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default Authenticated;
